import * as React from "react"

function SvgExpand(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path stroke="currentColor" strokeLinecap="round" d="M9.5 1.5v13" />
      <path d="M13 10l2-2-2-2M14.5 8H11" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path stroke="currentColor" strokeLinecap="round" d="M6.5 1.5v13" />
      <path d="M3 10L1 8l2-2M1.5 8H5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default SvgExpand
